import React from 'react';
import CurrentApp from './current/CurrentApp';

const App: React.FC = () => {
  return <CurrentApp />;
};

export default App;
